import { useGetAlboCfgTipi } from '@framework/common-web/register-records/frontoffice/api/configurazione-tipo-albo/configurazione-tipo-albo.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { generatePath } from '@framework/ui/core/router/TypedRoute.tsx';
import { useMemo } from 'react';
import { type MenuItemsProps, MenuItemsType } from '../../menu/MainMenu.tsx';

export default function useRegisterRecordsMenuItems() {
  const {
    data: registerRecordTypes,
    error,
    isLoading,
  } = useGetAlboCfgTipi({
    query: {
      enabled: !!process.env.BUILD_FLAGS_REGISTER_RECORDS,
      keepPreviousData: true,
    },
  });

  const menuItems: MenuItemsProps[] = useMemo(() => {
    if (isLoading) {
      return [
        {
          menuKey: 'elenchi-loading',
          type: MenuItemsType.LEAF,
          to: generatePath('/', {}),
          children: <></>,
          loading: true,
        },
      ];
    }

    if (error || !registerRecordTypes?.length) {
      return [];
    }

    if (registerRecordTypes.length === 1) {
      const tipo = registerRecordTypes[0];
      return [
        {
          menuKey: `elenchi-${tipo.id}`,
          to: generatePath('/albo/lista/:id', {
            id: tipo.id!,
          }),
          type: MenuItemsType.LEAF,
          loading: false,
          children: <>{tipo.denominazione}</>,
        },
      ];
    }

    return [
      {
        menuKey: 'elenchi-group',
        title: 'Elenchi',
        loading: false,
        type: MenuItemsType.PARENT,
        children: t('register-records.menu', 'Elenchi'),
        subMenu: registerRecordTypes.map(tipo => ({
          menuKey: `elenchi-${tipo.id}`,
          children: tipo.denominazione,
          title: tipo.denominazione,
          type: MenuItemsType.LEAF,

          to: generatePath('/albo/lista/:id', {
            id: tipo.id!,
          }),
        })),
      },
    ];
  }, [isLoading, error, registerRecordTypes]);

  return menuItems;
}
